import { reactive } from 'vue'
import { useExpose } from '@/composables/useExpose'
/**
 * Manage popup component state
 */
export function usePopupState() {
  const state = reactive({
    show: false,
  })

  const toggle = (show) => {
    state.show = show
  }

  const open = (props) => {
    Object.assign(state, props, { transitionAppear: true })
    toggle(true)
  }

  const close = () => toggle(false)

  const isShow = () => state.show

  useExpose({ open, close, toggle, isShow })

  return {
    open,
    close,
    state,
    toggle,
    isShow,
  }
}
